import { createInstance, baseURL, utilsHeaders } from '@cordata/buffet';

const baseInstance = createInstance({
  api: 'p',
  baseURL,
});

const sessionInstance = createInstance({
  api: 'p',
  baseURL,
  isAuthed: true,
});

const authorizedInstance = createInstance({
  api: 'p',
  baseURL: `${baseURL}/api`,
  isAuthed: true,
});

const utilsInstance = createInstance({
  baseURL: `${process.env.REACT_APP_UTILS_HOST_NAME}/api/v1`,
  headers: utilsHeaders,
});

const adminInstance = createInstance({
  api: 'p',
  baseURL: `${baseURL}/api/admin`,
  isAuthed: true,
});

export { baseInstance, sessionInstance, authorizedInstance, utilsInstance, adminInstance };
